import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { OperationsQuery } from './OperationsQuery.graphql';

export async function preloadOperations() {
	const { userId } = getPreloaderFnContext();
	if (!userId) {
		return;
	}

	/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
	return query({ query: OperationsQuery });
}
